import React from 'react'

import PropTypes from 'prop-types'

import useHydrated from 'Hooks/useHydrated'

const MobileSearchFields = ({ children }) => {
  const hydrated = useHydrated()

  if (!hydrated) {
    return null
  }

  return <>{children}</>
}

MobileSearchFields.defaultProps = {
  children: null,
}

MobileSearchFields.propTypes = {
  children: PropTypes.any,
}

export default MobileSearchFields
